window.dataLayer = window.dataLayer || [];

export const COOKIES = {
    ANALYTICS: 'eika_consent_analytics',
    MARKETING: 'eika_consent_marketing'
};

function splitCookie(cookie) {
    return cookie.split('=');
}
function getCookiesParsed() {
    return document.cookie
        .split(';')
        .map(c => c.trim())
        .map(splitCookie);
}

function getCookieValue(cookieName) {
    const cookie = getCookiesParsed().find(([cn]) => cn.trim() === cookieName);
    if (cookie) {
        return cookie[1] === 'true';
    }
    return false;
}


export function initGtm() {
    Object.values(COOKIES).forEach(triggerGTM);
}

/**
 * Method used before Cookie Consent solution is activated to mimick its use
 * */
export function activateGtm() {
    Object.values(COOKIES).forEach(cookieName => {
        window.dataLayer.push({
            event: 'eika_cookie_consent_changed',
            [cookieName]: true
        });
    });
}

export function activateAnalyticsOnly() {
    window.dataLayer.push({
        event: 'eika_cookie_consent_changed',
        [COOKIES.ANALYTICS]: true
    });
}

function triggerGTM(cookieName) {
    const value = getCookieValue(cookieName);
    window.dataLayer.push({
        event: 'eika_cookie_consent_changed',
        [cookieName]: value
    });
}

export function when(cookieName) {
    return new Promise((resolve, reject) => {
        if (getCookieValue(cookieName)) {
            resolve();
        } else {
            reject();
        }
        window.addEventListener(cookieName, function () {
            if (getCookieValue(cookieName)) {
                resolve();
            } else {
                reject();
            }
        });
    });
}